import ChevronDownIcon from "@/app/assets/icons/ChevronDownIcon";
import { Button, Dropdown } from "flowbite-react";
import React from "react";
import { HiCheck } from "react-icons/hi2";

type Props = {
  options: Array<{
    value: string | number;
    label: string | number;
    extra?: string;
  }>;
  placeholder?: string;
  value?: string | number;
  height?: string;
  onSelectValue: (value: string | number) => any;
};

const QuestionCustomSelect = ({
  value,
  options,
  placeholder,
  height,
  onSelectValue,
}: Props) => {
  return (
    <Dropdown
      label=""
      renderTrigger={() => (
        <button
          className={`flex min-h-[56px] ${
            height ? height : ""
          } w-full items-center rounded-lg border border-secondary bg-white px-4 py-[18px] text-sm ring-offset-white focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[placeholder]:text-grey [&>span]:line-clamp-1`}
        >
          <React.Fragment>
            {value ? (
              <div className="flex flex-col gap-1 w-full items-start truncate mr-auto">
                <div className="truncate max-w-[90%]">
                  {options.find((item) => item.value === value)?.label || value}
                </div>
                {options.find((item) => item.value === value)?.extra && (
                  <div className="text-xs text-gray-500 truncate max-w-[90%]">
                    {options.find((item) => item.value === value)?.extra}
                  </div>
                )}
              </div>
            ) : (
              <p className="text-left text-gray-500 mr-auto">
                {placeholder ? placeholder : "Choisissez un motif"}
              </p>
            )}
          </React.Fragment>
          <span className="shrink-0">
            <ChevronDownIcon />
          </span>
        </button>
      )}
      className="max-h-80 overflow-auto"
    >
      {options.map((option) => (
        <Dropdown.Item
          key={option.value}
          onClick={() => onSelectValue(option.value)}
          className="z-[99]"
        >
          <div className="w-6">
            {value && (option.value === value || option.label === value) ? (
              <HiCheck />
            ) : (
              ""
            )}
          </div>

          <div className="flex flex-col gap-1 justify-start items-start">
            {option.label}
            {option.extra && (
              <div className="text-xs text-gray-500">{option.extra}</div>
            )}
          </div>
        </Dropdown.Item>
      ))}
    </Dropdown>
  );
};

export default QuestionCustomSelect;
